export enum LanguagePreferenceType {
  English = 'en-US',
  Spanish = 'es-US',
  Mexico = 'es-MX',
}
